module.exports = __webpack_public_path__ + "img/narasi-case.c2c32154.jpg";